import { takeEvery, put, call } from "redux-saga/effects"

// Calender Redux States
import {
    GET_PAYMENT_LISTING,
    UPDATE_PAYMENT,
    GET_PAYMENT_DETAILS,
    UPDATE_PAYMENT_CONFIGURATION,
    ADD_PAYMENT,
    DELETE_PAYMENT,
} from "./actionTypes.js";

import {
    getPaymentListingSuccess,
    getPaymentListingFail,
    updatePaymentSuccess,
    updatePaymentFail,
    getPaymentDetailsSuccess,
    getPaymentDetailsFail,
    updatePaymentConfigurationSuccess,
    updatePaymentConfigurationFail,
    deletePaymentSuccess,
    deletePaymentFail,
    addPaymentSuccess,
    addPaymentFail,
} from "./actions.js";

import {
    paymentListingApi,
    updatePaymentApi,
    paymentDetailsApi,
    updatePaymentConfigurationApi,
    deletePaymentApi,
    addPaymentApi,
} from "./paymentApi.js";

function* fetchPaymentListing({ payload }) {
    try {
        const response = yield call(paymentListingApi, payload);
        yield put(getPaymentListingSuccess(response));
    } catch (error) {
        yield put(getPaymentListingFail(error));
    }
}

function* fetchPaymentDetail({ payload }) {
    try {
        const response = yield call(paymentDetailsApi, payload);
        yield put(getPaymentDetailsSuccess(response));
    } catch (error) {
        yield put(getPaymentDetailsFail(error));
    }
}

function* updatePayment({ payload }) {
    try {
        const response = yield call(updatePaymentApi, payload);
        yield put(updatePaymentSuccess(response));
    } catch (error) {
        yield put(updatePaymentFail(error));
    }
}

function* addPayment({ payload }) {
    try {
        const response = yield call(addPaymentApi, payload);
        yield put(addPaymentSuccess(response));
    } catch (error) {
        yield put(addPaymentFail(error));
    }
}

function* deletePayment({ payload }) {
    try {
        const response = yield call(deletePaymentApi, payload);
        yield put(deletePaymentSuccess(response));
    } catch (error) {
        yield put(deletePaymentFail(error));
    }
}

function* updatePaymentConfiguration({ payload }) {
    try {
        const response = yield call(updatePaymentConfigurationApi, payload);
        yield put(updatePaymentConfigurationSuccess(response));
    } catch (error) {
        yield put(updatePaymentConfigurationFail(error));
    }
}

function* PaymentSaga() {
    yield takeEvery(GET_PAYMENT_LISTING, fetchPaymentListing);
    yield takeEvery(GET_PAYMENT_DETAILS, fetchPaymentDetail);
    yield takeEvery(UPDATE_PAYMENT, updatePayment);
    yield takeEvery(ADD_PAYMENT, addPayment);
    yield takeEvery(DELETE_PAYMENT, deletePayment);
    yield takeEvery(UPDATE_PAYMENT_CONFIGURATION, updatePaymentConfiguration);

}

export default PaymentSaga
